// src/hooks/useUserProfile.ts
import { useState, useEffect } from 'react';
import { ref, get } from 'firebase/database';
import { db } from '../lib/firebase';

interface UserProfile {
  firstName?: string;
  lastName?: string;
  phone?: string;
  address?: string;
  credits?: number;
  createdAt?: string;
  updatedAt?: string;
}

export const useUserProfile = (userId: string | undefined) => {
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadProfile = async () => {
      if (!userId) {
        setLoading(false);
        return;
      }

      try {
        // Load profile data
        const profileRef = ref(db, `profiles/${userId}`);
        const profileSnapshot = await get(profileRef);
        
        // Load credits data
        const creditsRef = ref(db, `credits/${userId}`);
        const creditsSnapshot = await get(creditsRef);
        
        let totalCredits = 0;
        if (creditsSnapshot.exists()) {
          const creditsData = creditsSnapshot.val();
          totalCredits = Object.values(creditsData).reduce((sum: number, credit: any) => {
            return sum + (credit.amount || 0);
          }, 0);
        }

        const profileData: UserProfile = {
          ...(profileSnapshot.exists() ? profileSnapshot.val() : {}),
          credits: totalCredits,
          createdAt: profileSnapshot.exists() ? profileSnapshot.val().createdAt : new Date().toISOString(),
          updatedAt: new Date().toISOString()
        };

        setProfile(profileData);
      } catch (err) {
        console.error('Erreur lors du chargement du profil:', err);
        setError('Erreur lors du chargement du profil');
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, [userId]);

  return { profile, loading, error };
};
